<template>
    <div class="a-vs-c--ticket a-vs-c--single-ticket single-ticket__success" @click="onSelectItem()">
			<!-- Visible div -->
			<div class="a-vs-b--visible-block">
				<!-- <div class="single-ticket--row">
					<span>{{ $t('date') }}:</span>
					<div class="date-time">
						<span>{{getDate(ticket.DateTime)}}</span>
						<span>{{getTime(ticket.DateTime)}}</span>
					</div>
				</div> -->
        <div class="single-ticket--row">
					<span>{{$t('id')}}:</span>
					<span class="value-field status">{{ getTicketId(ticket) }}</span>
				</div>
				<div class="single-ticket--row">
					<span>{{ $t('status') }}:</span>
					<span class="value-field status">{{ getStatus(ticket) }}</span>
				</div>
				<div class="single-ticket--row">
					<span>{{$t('tipsNumber')}}:</span>
					<span class="value-field">{{ticket.Tips.length}}</span>
				</div>
				<!-- Hidden div -->
        <active-ticket-summary
            class="hidden-rows"
            :class="{'hide': ticket.isOpen}"
            :ticket="ticket"
            :isHistory="isHistory"
            :showTotalOdd="false"/>

			</div>

			<!-- Toggle "button" -->
			<div class="collapsed-block--toggle" @click="toggleTicketView(ticket)">
        <svg class="a-vs-icon" :class="{'rotation': ticket.isOpen}">
					<use xlink:href="@/assets/images/sprite.svg#arrow-expand"></use>
				</svg>
			</div>

			<div class="a-vs-b--collapsed-block" :class="{'visible': ticket.isOpen}">
				<!-- Single event -->
        <active-ticket-single-event
            v-for="(tip, index) in ticket.Tips" :key="index"
            class="single-event"
            :ticket="tip"
            :isActiveTicket="isActiveTicket(ticket)" />

				<!-- Quotes, stakes and wins -->
        <active-ticket-summary
            class="quotes-stakes"
            :ticket="ticket"
            :isHistory="isHistory"
            :hideWinning="hideWinning"
            :showTotalOdd="true"/>

        <active-ticket-possible-win-summary
            v-if="isHistory"
            class="win"
            :ticket="ticket"/>
			</div>
		</div>
</template>

<script>

import NumberFormat from '@/mixins/NumberFormat'
import TimeFormatter from '@/mixins/TimeFormatter'
import VSoccerTicketHelper from '@/mixins/VSoccerTicketHelper'
import ActiveTicketSummary from '@/components/soccer/ticket/ActiveTicketSummary.vue'
import ActiveTicketSingleEvent from '@/components/soccer/ticket/ActiveTicketSingleEvent.vue'
import ActiveTicketPossibleWinSummary from '@/components/soccer/ticket/ActiveTicketPossibleWinSummary.vue'

import vuexStore from '../../../store/vuexStore'

import activeBet from '../../../assets/audio/vSoccer/active_bet.mp3'

export default {
  mixins: [NumberFormat, VSoccerTicketHelper, TimeFormatter],
  components: {
    'active-ticket-summary': ActiveTicketSummary,
    'active-ticket-single-event': ActiveTicketSingleEvent,
    'active-ticket-possible-win-summary': ActiveTicketPossibleWinSummary
  },
  props: {
    ticket: {
      type: Object,
      required: true
    },
    isHistory: {
      type: Boolean,
      required: false
    },
    hideWinning: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted: function () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  methods: {
    onSelectItem: function () {
      if (this.hasAudioEnabled) {
        var audio = new Audio(activeBet)
        audio.play()
      }
      this.$emit('onSelectItem')
    },
    isActiveTicket: function (ticket) {
      return ticket.Status === 2
    },
    toggleTicketView (ticket) {
      ticket.isOpen = !ticket.isOpen
    },
    getTicketId (ticket) {
      return ticket.TicketCheckId || ticket.TicketCheckID
    },
    getStatus: function (ticket) {
      let status = this.$t('lostTicket')
      if (ticket.Status === 1) {
        status = this.$t('winning')
      } else if (ticket.Status === 2) {
        status = this.$t('activeTicket')
      }
      return status
    }
  }
}
</script>
